import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=181ce3f0&scoped=true&"
import script from "./LocationCard.vue?vue&type=script&lang=js&"
export * from "./LocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ce3f0",
  null
  
)

export default component.exports